import React from 'react';
import Orientation2024  from 'views/Orientation2024';

const ExtraCurricularActivitiesPage = () => {
  return <Orientation2024 />;
};

export default ExtraCurricularActivitiesPage;